import { gql } from '@apollo/client';

export const USER_ITEMS = gql`
query getUserItems($input: UserSearch) {
  getUserItems(input: $input) {
    id
    role
    email
    canAccess
  }
}
`;